const urlPrefix = `/IlocosSur/Legislative/api`;
var vRecID;

const newsMethod = (_url, _data) => {
    return new Promise(resolve => {
        var settings = {
            "url": `${urlPrefix}/leg-track/${_url}`,
            "method": "POST",
            "data": _data,
            "headers": {
                /* "Content-Type": "application/json" */
            }
        };
        $.ajax(settings)
            .always(function(msg) {
                resolve(msg);
            });
    });
}

const newsOnClick = (e) => {
    _showLoading();
    vRecID = e;
    newsMethod("get-newsDtl", { "recid": vRecID }).then((data) => {
        if (data.success) {
            $("#news-title").html(data.title);
            $("#news-date").html(data.date);

            if (data.img == "") {
                $("#news-image").addClass("d-none");
            } else {
                $("#news-image").removeClass("d-none");
                $("#news-image").attr("src", "/IlocosSur/news/" + data.img);
            }

            $("#news-body").html(data.desc);

            $("#newsModal").modal('show');
        } else {
            _notif("error", data.message);
        }
        _hideLoading();
    });
}

window.newsOnClick = newsOnClick
$(() => {
    _showLoading();
    newsMethod("get-newsList").then((data) => {
        var img, title, date;

        $.each(data, function(i, record) {
            for (var i in record) {

                img = '<div class="col-12 text-center mb-3 min-h-200-px"> <img src="/IlocosSur/news/' + record[i].img + '" class="mw-100" alt="' + record[i].img + '" height="200"> </div>';
                title = '<a href="#" class="text-decoration-none text-dark text-hdr fs-5 fw-semibold ls-7 mb-0 text-uppercase" onclick="newsOnClick(' + record[i].id + ')">' + record[i].title + '</a>';
                date = '<p class="text-info">' + record[i].date + '</p>';

                var element = '<div class="col-md-4">' + img + title + date + '</div>';
                $("#div-row").append(element);
            }
        });

        _hideLoading();
    });
});